<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">コンテナ種別詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_CT_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :disabled="isEdit"
                :rules="codeRules"
                clearable
                label="コンテナタイプ"
                v-model.trim="form.code"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="nameRules"
                clearable
                label="コンテナ名称"
                v-model="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="m3Rules"
                clearable
                label="最大積載M3"
                v-model="form.max"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
      },
      nameRules: [(v) => !!v || "Name is required"],
      codeRules: [(v) => !!v || "Code is required"],
      m3Rules: [(v) => !!v || "M3 is required"],
      errors: {
        CODE_EXISTS: "既存CDと重複したので、内容を変更してください。",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/container-types", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
};
</script>
